export default function ObjectNavigationFallback() {
  return (
    <div className="fixed bottom-0 left-0 w-full z-[1001]">
      <div className="h-[47px] bg-blue700 w-full rounded-t-[25px] py-3 px-3"></div>
      <div className="h-[63px] bg-white "></div>
    </div>
  );
}
